import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Tooltip, OverlayTrigger, Button, Badge } from "react-bootstrap";
import Edit from '../../../modal/Purchase_Management/Manage_Purchase/Edit';
import { Divider } from '@mui/material';
import swal from "sweetalert2"; 
import DatePicker, { DateObject } from "react-multi-date-picker";
import axios from 'axios';
import { useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
 import { useNavigate } from 'react-router-dom';
const EditPurchase = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const sno = queryParams.get('data');
    const [pendingMaterials, setPendingMaterials] = useState([]);
    const [showPendingTable, setShowPendingTable] = useState(false);

    const baseURL = process.env.REACT_APP_API_BASE_URL; 
    const [purchaseData, setPurchaseData] = useState(null);
    const [open, setOpen] = useState(false);  
    const [modalType, setModalType] = useState(""); 
    const [vendorList, setVendorList] = useState([]);  
    const [groupedOptions, setGroupedOptions] = useState([]);
    const [optionsUnits, setOptionsUnits] = useState([]); 
    const [selectedVendor, setSelectedVendor] = useState(null);  
    const [selectedRawMaterial, setSelectedRawMaterial] = useState(null);
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [brand, setBrand] = useState('');
    const [quantity, setQuantity] = useState('');
    const [estimateCost, setEstimateCost] = useState('');
    const [rawMaterialsList, setRawMaterialsList] = useState([]);
    const [errors, setErrors] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [editIndex, setEditIndex] = useState(null);


    const [selectedDate, setSelectedDate] = useState(null); 
 

    const [subTotal, setSubTotal] = useState(0); 
    const [totalAmount, setTotalAmount] = useState(0);
 

    // Custom group heading style
    const customStyles = {
        groupHeading: (provided) => ({
        ...provided,
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#333',
        }),
    };

    const Group = (props) => (
        <div style={customStyles}>
        <components.Group {...props} />
        </div>
    );

  const [staffOptions, setStaffOptions] = useState([]); 
  const [show, setShow] = useState(true); // adjust if using modal

useEffect(() => {
  if (purchaseData?.vendor_id) {
    const defaultVendor = {
      value: purchaseData.vendor_id,
      label: purchaseData.vendor_name
    };

    setSelectedVendor(defaultVendor);
    handleVendorChange(defaultVendor);
  }
}, [purchaseData]);



// Fetch staff options
useEffect(() => {
  axios.get(`${baseURL}/active-staff`)
    .then(res => {
      const options = res.data.data.map(s => ({  
        value: s.id,
        label: s.name
      }));
      setStaffOptions(options);
    })
    .catch(err => console.error("Failed to fetch staff list", err));
}, []);

const handleStaffChange = (selectedOption) => {
  setAssign({ staff: selectedOption });
  setErrors((prev) => ({ ...prev, staff: null })); // clear error on change
};


      const [assign, setAssign] = useState({
      staff: null 
    });

const branch_id = parseInt(localStorage.getItem("branch_id"), 10); 
const user_id = parseInt(localStorage.getItem("user_id"), 10);
const [vendors, setVendors] = useState([]); 
 
     useEffect(() => {
      const url = new URL(`${baseURL}/managevendor/vendors/active`);
      if (branch_id) {
        url.searchParams.append('branch_id', branch_id);
      }
    
      fetch(url.toString())
        .then((res) => res.json())
        .then((data) => {
          if (data.vendors) {
            setVendors(data.vendors);  // Save full vendor data
            const options = data.vendors.map((vendor) => ({
              value: vendor.sno,
              label: vendor.vendor_businessname,
            }));
            setVendorList(options);
          }
        })
        .catch((err) => console.error("Error fetching vendors:", err));
    }, [baseURL, branch_id]);


  useEffect(() => {
    fetch(`${baseURL}/raw-material-categories-with-materials`)
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          const options = data.data.map((category) => ({
            label: category.category_name,
            category_sno: category.category_id, // <-- capture for lookup
            raw_materials: category.raw_materials, // <-- include for deep access
            options: category.raw_materials.map((material) => ({
              value: material.sno,
              label: material.rawmaterial_name,
              categorySno: category.category_sno,

              rawmaterial_unit: material.rawmaterial_unit,
              rawmaterial_unit_name: material.rawmaterial_unit_name,
              base_cost: material.base_cost,
              brand_name: material.brand_name

            })),
          }));
          setGroupedOptions(options);
        }
      })
      .catch((err) => console.error("Failed to fetch raw materials:", err));
  }, [baseURL]);
 
  useEffect(() => {
    fetchUnitsByCategory(4, setOptionsUnits);
  }, [baseURL]);
 
  useEffect(() => {
    if (selectedRawMaterial && selectedRawMaterial.categorySno) {
      fetchUnitsByCategory(selectedRawMaterial.categorySno, setOptionsUnits);
      setSelectedUnit(null);
    }
  }, [selectedRawMaterial]);

 
const [rawMaterialOptions, setRawMaterialOptions] = useState([]); 

 

const handleVendorChange = async (selectedVendor) => {
  setSelectedVendor(selectedVendor);
  setSelectedRawMaterial(null);
  setBrand('');
  setQuantity('');
  setSelectedUnit(null);
  setEstimateCost('');

  // 1️⃣ Group raw materials for dropdown
  const vendorDetails = vendors.find(v => v.sno === selectedVendor.value);

  if (vendorDetails?.raw_materials) {
    const grouped = vendorDetails.raw_materials.reduce((groups, material) => {
      const category = material.rawmaterial_category_name || 'Others';
      if (!groups[category]) groups[category] = [];

      groups[category].push({
        value: material.rawmaterial_id,
        label: material.rawmaterial_name,
        raw_material_obj: material,
      });

      return groups;
    }, {});

    const groupedArray = Object.entries(grouped).map(([category, options]) => ({
      label: category,
      options,
    }));

    setGroupedOptions(groupedArray);
  } else {
    setGroupedOptions([]);
  }

  // 2️⃣ Fetch pending materials (same as Add Purchase)
  try {
    const vendorId = selectedVendor.value;
    const branchId = branch_id;

    const res = await axios.get(`${baseURL}/pending-materials/${branchId}/${vendorId}`);

    if (res.data?.data?.length > 0) {
      setPendingMaterials(res.data.data);
      setShowPendingTable(true);
    } else {
      setPendingMaterials([]);
      setShowPendingTable(false);
    }
  } catch (err) {
    console.error("Error fetching pending materials:", err);
    setPendingMaterials([]);
    setShowPendingTable(false);
  }
};


    const handleRawMaterialChange = (selected) => {
        setSelectedRawMaterial(selected);
        setErrors((prev) => ({ ...prev, rawMaterial: null }));
    };

    const handleUnitChange = (selected) => {
        setSelectedUnit(selected);
        setErrors((prev) => ({ ...prev, unit: null }));
    };
 
    const handleDeleteRawMaterial = (index) => {
        const updated = [...rawMaterialsList];
        updated.splice(index, 1);
        setRawMaterialsList(updated);
        };
  
useEffect(() => {
    if (sno) {
        axios.get(`${baseURL}/purchases/${sno}`)
            .then((res) => {
                const data = res.data?.data;
                if (data) {
                    setPurchaseData(data);

                    // Vendor
                    setSelectedVendor({
                        label: data.vendor_businessname,
                        value: data.vendor_id
                    });

                    // Purchase date
                    setSelectedDate(new DateObject(data.purchase_date));

                    // Raw materials
                    const formattedMaterials = data.raw_material.map((item) => ({
                            raw_material_name: item.rawmaterial_name,
                            raw_material_id: item.raw_material_id,
                            brand: item.brand,
                            quantity: item.quantity,
                            unit_label: item.unitslug_name, 
                                unit_value: item.unit_id,   
                            per_unit_cost: item.total_cost
                        }));
                    setRawMaterialsList(formattedMaterials);
 
                    setAssign({
                      staff: {
                          value: data.purchase_staff,       // must match backend sno/id
                          label: data.purchase_staffname    // display name
                      }
                  });

                }
            })
            .catch((err) => console.error("Error fetching purchase data:", err));
    }
}, [sno]);

    const handleUpdatePurchase = async () => { 
    let validationErrors = {};

    if (!selectedVendor) validationErrors.vendor = "Vendor is required";
   if (!assign.staff || !assign.staff.value) validationErrors.staff = "Staff is required";
    if (!selectedDate) validationErrors.purchaseDate = "Purchase date is required";
    if (rawMaterialsList.length === 0)
      validationErrors.rawMaterialsList = "Add at least one raw material";

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    const formattedDate =
      selectedDate.format
        ? selectedDate.format("YYYY-MM-DD")
        : selectedDate;

    const payload = { 
      vendor_id: selectedVendor.value,
      purchase_staff: assign.staff.value,
      purchase_date: formattedDate,
      updated_by: user_id, 
      raw_material: rawMaterialsList.map((item) => ({
        raw_material_id: item.raw_material_id,
        raw_material_name: item.raw_material_name,
        brand: item.brand,
        quantity: item.quantity,
        // unit_id: item.unit_value,
         unit_id: item.unit_value,   
        per_unit_cost: item.per_unit_cost, 
      })), 
    };

    console.log("Update Payload:", JSON.stringify(payload, null, 2));

    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to update this purchase?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, update it!",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        const response = await axios.post(`${baseURL}/purchases/${sno}`, payload);

        if (response.status === 200) {
          // Swal.fire("Updated!", "Purchase has been updated successfully.", "success");
          navigate('/manage-purchase', {
              state: { toastMessage: 'Purchase Updated Successfully!', toastType: 'success' }
          });
        } else {
          // Swal.fire("Error", "Failed to update purchase.", "error");
          navigate('/manage-purchase', {
              state: { toastMessage: 'Error Updating Purchase', toastType: 'error' }
          });
        }
      }
    } catch (error) {
      console.error("Error updating purchase:", error);
      // Swal.fire("Error", "Something went wrong. Please try again.", "error");
       navigate('/manage-purchase', {
          state: { toastMessage: 'Error Updating Purchase', toastType: 'error' }
      });
    }
  };


 
 const [totalEstimateCost, setTotalEstimateCost] = useState(0);
 
// const handleRawMaterialSelect = (selectedOption) => {
//   setSelectedRawMaterial(selectedOption);

//   // selectedOption.raw_material_obj has the full raw material details
//   const fullMaterial = selectedOption?.raw_material_obj;

//   if (fullMaterial) {
//     const qty = Number(fullMaterial.rawmaterial_quantity || 0);
//     const cost = Number(fullMaterial.base_cost || 0);

//     setBrand(fullMaterial.brand_name || '');
//     setQuantity(qty);
//     setFetchedQuantity(qty);
//     setFetchedTotalCost(cost);
//     setEstimateCost(cost.toFixed(2));

//     setSelectedUnit({
//       value: fullMaterial.rawmaterial_unit,
//       label: fullMaterial.rawmaterial_unit_name || '',
//     });
 
//   }
// };


// Fetch units by category

const handleRawMaterialSelect = async (selectedOption) => {
  setSelectedRawMaterial(selectedOption);

  const fullMaterial = selectedOption?.raw_material_obj;

  let latestPricePerAmount = null;

  try {
    const res = await fetch(`${baseURL}/raw-pricebook?vendor_id=${selectedVendor?.value}`);
    const result = await res.json();

    if (result?.data?.length > 0) {

      const priceItem = result.data.find(
        item => item.raw_material_id === selectedOption.value
      );

      if (priceItem?.prices) {
        const priceEntries = Object.entries(priceItem.prices);

        if (priceEntries.length > 0) {
          priceEntries.sort((a, b) => new Date(b[0]) - new Date(a[0]));
          latestPricePerAmount = Number(priceEntries[0][1]?.per_amount || 0);
        }
      }
    }
  } catch (error) {
    console.log("Pricebook Fetch Error:", error);
  }

  // ----- APPLY VALUES -----
  if (fullMaterial) {
    const qty = Number(fullMaterial.rawmaterial_quantity || 0);
    const baseCost = Number(fullMaterial.base_cost || 0);

    const perAmountCost = latestPricePerAmount ?? baseCost;

    const finalCost = perAmountCost * qty;

    setBrand(fullMaterial.brand_name || '');
    setQuantity(qty);
    setFetchedQuantity(qty);
    setFetchedTotalCost(perAmountCost);       // cost per unit
    setEstimateCost(finalCost.toFixed(2));    // total amount

    setSelectedUnit({
      value: fullMaterial.rawmaterial_unit,
      label: fullMaterial.rawmaterial_unit_name || '',
    });
  }
};



const fetchUnitsByCategory = async (categorySno, setOptions) => {
  try {
    const response = await axios.get(`${baseURL}/manageunit/by-category`, {
      params: { unit_category_sno: categorySno },
    });
    if (response.data.success) {
      const options = response.data.data.map((unit) => ({
        value: unit.unit_id,               // <-- fix: use unit_id
        label: unit.unitslug_name,
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  } catch (error) {
    console.error("Error fetching units by category:", error);
    setOptions([]);
  }
};

// Handle add/update raw material
const handleAddOrUpdateRawMaterial = () => {
  const newErrors = {};
  if (!selectedRawMaterial) newErrors.rawMaterial = 'Raw Material is required';
  if (!quantity || isNaN(quantity)) newErrors.quantity = 'Enter valid quantity';
  if (!selectedUnit) newErrors.unit = 'Unit is required';
  if (!estimateCost || isNaN(estimateCost)) newErrors.estimateCost = 'Enter valid amount';

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  const rawMaterialData = {
    raw_material_name: selectedRawMaterial.label,
    raw_material_id: selectedRawMaterial.value,
    brand,
    quantity,
    unit_label: selectedUnit.label,
    unit_value: selectedUnit.value,       // <-- this will now contain proper unit_id
    per_unit_cost: estimateCost,
    categorySno: selectedRawMaterial.categorySno,
  };

  if (isEditMode) {
    const updatedList = [...rawMaterialsList];
    updatedList[editIndex] = rawMaterialData;
    setRawMaterialsList(updatedList);
    setIsEditMode(false);
    setEditIndex(null);
  } else {
    setRawMaterialsList([...rawMaterialsList, rawMaterialData]);
  }

  // Clear form
  setSelectedRawMaterial(null);
  setBrand('');
  setQuantity('');
  setSelectedUnit(null);
  setEstimateCost('');
  setErrors({});
};

// Handle edit raw material
const handleEditRawMaterial = (index) => {
  const item = rawMaterialsList[index];
  setSelectedRawMaterial({
    label: item.raw_material_name,
    value: item.raw_material_id,
    categorySno: item.categorySno,
  });
  setBrand(item.brand);
  setQuantity(item.quantity);
  setSelectedUnit({ label: item.unit_label, value: item.unit_value });  // <-- fix
  setEstimateCost(item.per_unit_cost);
  setIsEditMode(true);
  setEditIndex(index);
};

const evaluateExpression = (expr) => {
  try {
    return Function(`"use strict"; return (${expr})`)();
  } catch {
    return 0;
  }
};

 
useEffect(() => {
  // Raw Materials Total
  const rawTotal = rawMaterialsList.reduce((sum, item) => {
    const unitCost = parseFloat(item.per_unit_cost || 0);
    const qty = parseFloat(item.quantity || 0);
    return sum + (unitCost);
  }, 0);

  // Pending Materials Total
  const pendingTotal = pendingMaterials
    .flatMap(item => {
      let list = [];
      try {
        list = JSON.parse(item.purchased_list);
      } catch {
        list = [];
      }

      return list
        .filter(mat => mat.amount_status === "0")
        .map(mat => {
          const materialObj = groupedOptions
            .flatMap(g => g.options)
            .find(rm => rm.value === mat.raw_material_id);

          const unitCost = parseFloat(materialObj?.base_cost || mat.base_cost || 0);
          const qty = parseFloat(mat.pending_quantity || 0);

          return unitCost + qty; // IMPORTANT
        });
    })
    .reduce((sum, cost) => sum + cost, 0);

  // Final
  setTotalEstimateCost(rawTotal + pendingTotal);
}, [rawMaterialsList, pendingMaterials, groupedOptions]);


const [perUnitCost, setPerUnitCost] = useState(0);
const [fetchedQuantity, setFetchedQuantity] = useState(0);
const [fetchedTotalCost, setFetchedTotalCost] = useState(0);
 


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Update Purchase</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Purchase Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-purchase'>Manage Purchase</Link></li>
                    </ol>
                </div>
            </div>
            <div className="row mb-2">

                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Purchase Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Date'
                            value={selectedDate}
                            onChange={setSelectedDate}
                            format="DD-MM-YYYY"
                        />
                            {errors.selectedDate && (
                            <span className="text-danger fs-7 mt-1 d-block">This field is required</span>
                        )}
                    </div>
                </div>
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Vendor<span className="required">*</span></label>
                    <Select
                        value={selectedVendor}
                        onChange={handleVendorChange}
                        options={vendorList}
                        placeholder="Select Vendor"
                        />
                        {errors.selectedVendor && (
                        <span className="text-danger fs-7 mt-1 d-block">This field is required</span>
                    )}
                </div>
               <div className="col-lg-3 mb-4">
                  <label className="text-black font-w500 fs-7">
                    Staff <span className="required">*</span>
                  </label>
                  <Select
                    placeholder="Select Staff"
                    options={staffOptions}
                    onChange={handleStaffChange}
                    value={assign.staff}
                  />
                  {errors.staff && (
                    <span className="text-danger fs-7 mt-1 d-block">{errors.staff}</span>
                  )}
                </div>



                <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column  align-items-center mb-3'>
                    <label className='text-gray-800 text-start font-w500 fs-7'>Raw Material Count</label>
                    <div className='d-block'>
                        <Badge bg="info" className='text-white fs-6 px-3 py-0'>{rawMaterialsList.length}</Badge>
                    </div>
                </div>
              
            </div>
            
             
                 <div className='card px-3 py-3 mb-6 border-success bg-success-light'>
                    <div className='row'>
                      <div className="col-lg-3 mb-4">
                        <label className="text-black font-w500 fs-7">
                          Raw Material<span className="required">*</span>
                        </label>
                     
                        <Select
                          options={groupedOptions}
                          components={{ Group }}
                          styles={{ groupHeading: customStyles.groupHeading }} 
                          onChange={handleRawMaterialSelect}
                          value={selectedRawMaterial}
                          placeholder="Select Raw Material" 
                        />

                        {errors.rawMaterial && <span className="text-danger fs-7">{errors.rawMaterial}</span>}
                      </div>
            
                      <div className='col-lg-2'>
                        <label className="text-black font-w500 fs-7">Brand</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Brand"
                          value={brand}
                          onChange={(e) => setBrand(e.target.value)}
                        />
                      </div>
            
                      <div className='col-lg-3 mb-4'>
                        <div className='row'>
                          <div className='col-lg-5'>
                            <label className="text-black font-w500 fs-7">
                              Quantity<span className="required">*</span>
                            </label>
{/*             
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Qty"
                                value={quantity}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setQuantity(value);
                                  setErrors((prev) => ({ ...prev, quantity: null })); 
                                  const newQty = parseFloat(value);
                                  if (!isNaN(newQty) && fetchedQuantity > 0) {
                                    const newCost = (newQty / fetchedQuantity) * fetchedTotalCost;
                                    setEstimateCost(newCost.toFixed(2));
                                  } else {
                                    setEstimateCost('');
                                  }
                                }}
                              /> */}
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Qty"
                                value={quantity}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setQuantity(value);
                                  setErrors((prev) => ({ ...prev, quantity: null }));

                                  const newQty = parseFloat(value);

                                  // Auto calculate: cost per unit × qty
                                  if (!isNaN(newQty)) {
                                    const newCost = newQty * fetchedTotalCost;
                                    setEstimateCost(newCost.toFixed(2));
                                  } else {
                                    setEstimateCost('');
                                  }
                                }}
                              />

             
                            {errors.quantity && <span className="text-danger fs-7">{errors.quantity}</span>}
                          </div>
                          <div className='col-lg-7'>
                            <label className="text-black font-w500 fs-7">
                              Units<span className="required">*</span>
                            </label>
                            <Select
                              options={optionsUnits}
                              onChange={handleUnitChange}
                              value={selectedUnit}
                              placeholder="Select Unit"
                            />
                            {errors.unit && <span className="text-danger fs-7">{errors.unit}</span>}
                          </div>
                        </div>
                      </div>
            
                      <div className='col-lg-2'>
                        <label className="text-black font-w500 fs-7">
                          Estimate Cost<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Amount"
                          value={estimateCost}
                          onChange={(e) => {
                            setEstimateCost(e.target.value);
                            setErrors((prev) => ({ ...prev, estimateCost: null }));
                          }}
                          readOnly
                        />
                        {errors.estimateCost && <span className="text-danger fs-7">{errors.estimateCost}</span>}
                      </div>
            
                      <div className='col-lg-2 d-flex align-items-center'>
                        <Button className="me-2" variant="primary" size='sm' onClick={handleAddOrUpdateRawMaterial}> 
                          {isEditMode ? 'Update' : 'Add'}
                        </Button>
                       
                        <Button
                        className="me-2 text-white"
                        variant="danger light"
                        size="sm"
                        onClick={() => {
                          setSelectedRawMaterial(null);
                          setBrand('');
                          setQuantity('');
                          setSelectedUnit(null);
                          setEstimateCost('');
                          setErrors({});
                          setIsEditMode(false);
                          setEditIndex(null);
                        }}
                      >
                        Clear
                      </Button>
                      </div>
                    </div>
                    {errors.rawMaterialsList && (
                          <div className="text-danger mt-2 fs-7 text-start pe-4">
                            {errors.rawMaterialsList}
                          </div>
                        )}
                  </div>
  
            <div className="table-container">
              <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                <thead>
                  <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                    <th className='min-w-100px'>Raw Material</th>
                    <th className='min-w-100px'>Brand</th>
                    <th className='min-w-50px'>Qty / Units</th>
                    <th className='min-w-50px'>Amount</th>
                    <th className='min-w-50px text-end'>Action</th>
                  </tr>
                </thead> 
                <tbody className="text-gray-600 fw-semibold fs-7"> 
                  {[ 
                    ...rawMaterialsList.map(rm => ({
                      ...rm,
                      isPending: false // editable items
                    })),

                    // Attach pending items
                    ...pendingMaterials.flatMap(item => {
                      let list = [];
                      try { list = JSON.parse(item.purchased_list); }
                      catch { list = []; }

                      return list
                        .filter(mat => mat.amount_status === "0")
                        .map(mat => {
                          const materialObj = groupedOptions
                            .flatMap(group => group.options)
                            .find(rm => rm.value === mat.raw_material_id);

                      
                            return {
                              ...mat,
                              raw_material_name: materialObj?.label || `ID: ${mat.raw_material_id}`,

                              unit_label:
                                materialObj?.raw_material_obj?.rawmaterial_unit_name ||
                                mat.unitslug_name ||
                                "-",

                              per_unit_cost:
                                materialObj?.raw_material_obj?.base_cost ||
                                mat.base_cost ||
                                0,

                              quantity: mat.pending_quantity,
                              isPending: true
                            };
                        });
                    }),
                  ].map((item, index) => {

                    return (
                      <tr key={index}>
                        <td>
                          <label className="text-black font-w400 fs-7">
                            {item.raw_material_name}
                          </label>
                        </td>

                        <td>
                          {item.brand && (
                            <label className="text-black font-w400 fs-7">
                              {item.brand}
                            </label>
                          )}
                        </td>

                        <td>
                          <label className="text-black font-w400 fs-7">
                            {item.quantity} {item.unit_label}
                          </label>
                        </td>

                        <td className="text-end">
                          <span className="badge bg-danger text-white fs-7 py-0 px-1">
                            <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                            {evaluateExpression(item.per_unit_cost)}
                          </span>
                        </td>

                        <td className="text-end">
                          {!item.isPending && (
                            <span>
                              <OverlayTrigger
                                trigger={['hover', 'focus']}
                                placement="bottom"
                                overlay={
                                  <Tooltip className="toltip-popover">
                                    <span className="fs-8 text-white fw-semibold">Edit</span>
                                  </Tooltip>
                                }
                              >
                                <Link>
                                  <Button
                                    variant="primary tp-btn-light px-2 py-1 me-1"
                                    onClick={() => handleEditRawMaterial(index)}
                                  >
                                    <i className="fa-solid fa-pen-to-square fs-6 mt-1"></i>
                                  </Button>
                                </Link>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger={['hover', 'focus']}
                                placement="bottom"
                                overlay={
                                  <Tooltip className="toltip-popover">
                                    <span className="fs-8 text-white fw-semibold">Delete</span>
                                  </Tooltip>
                                }
                              >
                                <Link>
                                  <Button
                                    variant="primary tp-btn-light px-2 py-1 me-1"
                                    onClick={() => handleDeleteRawMaterial(index)}
                                  >
                                    <svg width="25px" height="25px" viewBox="0 -5 32 32" xmlns="http://www.w3.org/2000/svg" fill="#025d3a">
                                      <path d="M22.708,6.28c-0.394-0.39-1.032-0.39-1.427,0l-2.3,2.3-2.239-2.24c-0.39-0.39-1.024-0.39-1.415,0 
                                        c-0.391,0.39-0.391,1.03,0,1.42l2.239,2.23-2.268,2.27c-0.394,0.39-0.394,1.03,0,1.43c0.394,0.39,1.033,0.39,1.427,0 
                                        l2.268-2.26 2.239,2.24c0.391,0.39,1.025,0.39,1.415,0c0.391-0.4,0.391-1.04,0-1.43l-2.239-2.23 2.3-2.29
                                        C23.103,7.31,23.103,6.67,22.708,6.28zM29.998,17c0,1.1-0.896,2-2.002,2H10.467L2.316,9.98 10.438,1H27.996
                                        c1.106,0,2.002,0.9,2.002,2v14zM27.996,0H10.051c-0.28-0.02-0.566,0.07-0.78,0.28L0.285,10.22
                                        c-0.211,0.21-0.302,0.49-0.287,0.76c-0.015,0.28,0.076,0.56,0.287,0.77l9.986,9.94c0.196,0.19,0.452,0.28,0.708,0.28h18.017
                                        C30.207,22,32,20.21,32,18V4C32,1.79,30.207,0,27.996,0z"/>
                                    </svg>
                                  </Button>
                                </Link>
                              </OverlayTrigger>
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })} 
                </tbody> 
                <tfoot>
                  <tr>
                    <td colSpan={2}></td>
                    <td className='text-end'>
                      <label className='fs-5 fw-bold text-black'>Total Estimated Cost</label>
                    </td>
                    <td className='text-end'>
                      <label className='fs-5 fw-bold text-danger'>
                        ₹ {totalEstimateCost.toFixed(2)}
                      </label>
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              </table> 
              {showPendingTable && pendingMaterials.length > 0 && (
                <div className="mt-5">
                  <h5 className="text-success mb-3">Pending Materials for Selected Vendor</h5>
                  <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                      <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                        <th className='min-w-50px'>S.No</th>
                        <th className='min-w-100px'>Purchase Date</th>
                        <th className='min-w-150px'>Raw Material</th> 
                        <th className='min-w-50px'>Quantity / Unit</th>  
                      </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                      {pendingMaterials.map((item, index) => {
                        let list = [];
                        try {
                          list = JSON.parse(item.purchased_list);
                        } catch {
                          list = [];
                        }

                        return list
                          .filter(mat => mat.amount_status === "1") // only included
                          .map((mat, i) => {
                            // Find the raw material object to get name and unit
                            const materialObj = groupedOptions
                              .flatMap(group => group.options)
                              .find(rm => rm.value === mat.raw_material_id);

                            const rawMaterialName = materialObj?.label || `ID: ${mat.raw_material_id}`;
                            const unitName = materialObj?.rawmaterial_unit_name || mat.unitslug_name || '-';

                            return (
                              <tr key={`${index}-${i}`}>
                                <td className='text-black'><label className='text-black font-w600 fs-7'>{index + 1}</label></td>
                                <td><label className='text-black font-w600 fs-7'>{item.purchased_date}</label></td>
                                <td>
                                    <label className='text-black font-w600 fs-7'>
                                      {rawMaterialName} {(mat.brand) || ''}
                                    </label>
                                  </td> 
                                <td className='text-black'><label className='text-black font-w600 fs-7'>{mat.pending_quantity} {unitName}</label></td> 
                              </tr>
                            );
                          });
                      })}
                    </tbody>
                  </table>
                </div>
              )} 
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4" >
                  <Link to={'/manage-purchase'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                  <Link to={'#'} onClick={handleUpdatePurchase} type="submit" className="btn btn-sm btn-primary">Update Purchase</Link>
            </div >
        </>
    )

}
export default EditPurchase;